var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVariantSwitcherPlugin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 16,
    width: 171.12,
    height: 171.12,
    rx: 16,
    transform: "rotate(45 128 16)",
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 8,
    y: 35,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 8,
    y: 83,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 56,
    y: 83,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 56,
    y: 35,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 13,
    y1: 45,
    x2: 13,
    y2: 83,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 61,
    y1: 45,
    x2: 61,
    y2: 83,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 56,
    y1: 88,
    x2: 18,
    y2: 88,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 56,
    y1: 40,
    x2: 18,
    y2: 40,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 191,
    y: 5,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 191,
    y: 53,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 239,
    y: 53,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 239,
    y: 5,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 196,
    y1: 15,
    x2: 196,
    y2: 53,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 244,
    y1: 15,
    x2: 244,
    y2: 53,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 239,
    y1: 58,
    x2: 201,
    y2: 58,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 239,
    y1: 10,
    x2: 201,
    y2: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 145,
    y: 28,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 209,
    y: 28,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 150,
    y1: -10,
    x2: 150,
    y2: 28,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 214,
    y1: -10,
    x2: 214,
    y2: 28,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 209,
    y1: 33,
    x2: 155,
    y2: 33,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 73,
    y: 1,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 73,
    y: 83,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 121,
    y: 83,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 121,
    y: 1,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 78,
    y1: 11,
    x2: 78,
    y2: 83,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 126,
    y1: 11,
    x2: 126,
    y2: 83,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 121,
    y1: 88,
    x2: 83,
    y2: 88,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 121,
    y1: 6,
    x2: 83,
    y2: 6,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 37,
    y: 11,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 42,
    y1: -61,
    x2: 42,
    y2: 11,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 37,
    y1: 16,
    x2: -1,
    y2: 16,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 26,
    y: 186,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 26,
    y: 104,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 31,
    y1: 114,
    x2: 31,
    y2: 186,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 26,
    y1: 191,
    x2: -12,
    y2: 191,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 26,
    y1: 109,
    x2: -12,
    y2: 109,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 161,
    y: 74,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 161,
    y: 156,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 209,
    y: 156,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 209,
    y: 74,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 166,
    y1: 84,
    x2: 166,
    y2: 156,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 214,
    y1: 84,
    x2: 214,
    y2: 156,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 209,
    y1: 161,
    x2: 171,
    y2: 161,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 209,
    y1: 79,
    x2: 171,
    y2: 79,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 10,
    y: 168,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 58,
    y: 168,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 15,
    y1: 178,
    x2: 15,
    y2: 269,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 63,
    y1: 178,
    x2: 63,
    y2: 269,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 58,
    y1: 173,
    x2: 20,
    y2: 173,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 43,
    y: 207,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 43,
    y: 238,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91,
    y: 238,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91,
    y: 207,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 48,
    y1: 217,
    x2: 48,
    y2: 238,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 96,
    y1: 217,
    x2: 96,
    y2: 238,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 91,
    y1: 243,
    x2: 53,
    y2: 243,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 91,
    y1: 212,
    x2: 53,
    y2: 212,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 180,
    y: 168,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 180,
    y: 231,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 235,
    y: 231,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 235,
    y: 168,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 185,
    y1: 178,
    x2: 185,
    y2: 231,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 240,
    y1: 178,
    x2: 240,
    y2: 231,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 235,
    y1: 236,
    x2: 190,
    y2: 236,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 235,
    y1: 173,
    x2: 190,
    y2: 173,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 111,
    y: 224,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 166,
    y: 224,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 116,
    y1: 234,
    x2: 116,
    y2: 287,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 171,
    y1: 234,
    x2: 171,
    y2: 287,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 166,
    y1: 229,
    x2: 121,
    y2: 229,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 234,
    y: 74,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 234,
    y: 140,
    width: 10,
    height: 10,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 239,
    y1: 84,
    x2: 239,
    y2: 140,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 282,
    y1: 145,
    x2: 244,
    y2: 145,
    stroke: "#B3D7EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 282,
    y1: 79,
    x2: 244,
    y2: 79,
    stroke: "#B3D7EC",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 7,
    width: 171.12,
    height: 171.12,
    rx: 16,
    transform: "rotate(45 128 7)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.681,
    y: 22.3624,
    width: 69.8194,
    height: 69.8194,
    rx: 10,
    transform: "rotate(45 127.681 22.3624)",
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.63,
    y: 78.3114,
    width: 69.8194,
    height: 69.8194,
    rx: 10,
    transform: "rotate(45 183.63 78.3114)",
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.7324,
    y: 78.3114,
    width: 69.8194,
    height: 69.8194,
    rx: 10,
    transform: "rotate(45 71.7324 78.3114)",
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.681,
    y: 134.26,
    width: 69.8194,
    height: 69.8194,
    rx: 10,
    transform: "rotate(45 127.681 134.26)",
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7605 163.302C106.842 170.002 117.002 173.681 127.5 173.708C133.469 173.794 139.395 172.697 144.938 170.48C150.48 168.263 155.528 164.97 159.792 160.792C164.491 156.75 168.34 151.814 171.112 146.27C173.884 140.725 175.524 134.685 175.937 128.5C176.47 121.924 175.694 115.308 173.655 109.034C171.615 102.759 168.352 96.9514 164.054 91.9459C174.77 101.219 181.367 114.366 182.396 128.5C183.006 135.951 182.127 143.449 179.81 150.556C177.492 157.664 173.46 163.851 168.575 169.511C162.409 175.73 154.917 180.476 146.658 183.394C138.4 186.311 129.59 187.325 120.885 186.358C112.18 185.392 103.806 182.471 96.3885 177.814C88.9711 173.157 82.7021 166.883 78.0499 159.463C73.3976 152.042 70.4825 143.666 69.5223 134.961C68.562 126.255 69.5815 117.445 72.5046 109.189C75.4277 100.933 80.1787 93.4441 86.4027 87.2822C92.6268 81.1202 100.163 76.4444 108.448 73.6043C109.188 69.1042 111.491 65.0092 114.952 62.0402C118.414 59.0711 122.812 57.4183 127.372 57.3727C131.933 57.327 136.363 58.8914 139.883 61.7906C143.404 64.6897 145.788 68.7378 146.618 73.2221C147.448 77.7065 146.669 82.3398 144.419 86.3065C142.168 90.2732 138.591 93.319 134.316 94.9079C130.042 96.4967 125.343 96.5267 121.049 94.9926C116.754 93.4585 113.138 90.4586 110.837 86.5209C101.09 90.417 93.0016 97.584 87.9609 106.792C82.9202 116 81.2411 126.676 83.2116 136.986C85.1821 147.297 90.6795 156.601 98.7605 163.302ZM127.5 86.0001C132.747 86.0001 137 81.7468 137 76.5001C137 71.2534 132.747 67.0001 127.5 67.0001C122.253 67.0001 118 71.2534 118 76.5001C118 81.7468 122.253 86.0001 127.5 86.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariantSwitcherPlugin);
export default __webpack_public_path__ + "static/media/variant-switcher-plugin.333722bb8fa35dab98c912d9a7bc783b.svg";
export { ForwardRef as ReactComponent };